Namespace 'Settings.Views.AccountSettings.SocialAccounts'

class Settings.Views.AccountSettings.SocialAccounts.CreateGooglePlayAccountView extends Backbone.View
  className: 'modal hide fade in'
  template: JST['backbone/templates/account_settings/social_accounts/create_google_play_account']

  events:
    'click #submit': 'submit'
    'click #cancel': 'redirectToSocialAccounts'

  initialize: (account) ->
    @account = account
    @modal = buttons: [], title: I18n.t('social_accounts.google_play.create.title')

  render: ->
    @$el.html(@template({account: @account}))
    @$el.modal({backdrop: 'static', keyboard: false})
    @_addEventListenerFileReader()
    @$el.modal()

  _addEventListenerFileReader: ->
    @$el.find('#json_file').on('change', =>
      @$el.find('#json_file_value').html(json_file.files[0].name || '')
      reader = new FileReader
      reader.addEventListener('load', =>
        @file_json_as_string = reader.result
      , false)
      reader.readAsText(@$el.find('#json_file').get(0).files[0])
    )

  submit: (event) ->
    name = @$el.find('#name').val()
    if (@file_json_as_string)
      @$el.children('.tab-content').empty().addClass('processing')
      @_createAccount(@file_json_as_string, name)
    else
      swal({
        title: I18n.t('social_accounts.google_play.create.error_notification.title'),
        text: I18n.t('social_accounts.google_play.create.error_notification.json_file_mandatory'),
        type: 'error',
        showCancelButton: false,
        closeOnConfirm: true
      })

  _createAccount: (file_json_as_string, name) ->
    @account.set('json_file', file_json_as_string)
    if (name != '')
      @account.set('name', name)
    else
      @account.set('name', @account.get('info').name)
    @account.save(null, {
      success: @redirectToSocialAccounts,
      error: @onError
    })

  redirectToSocialAccounts: ->
    window.location = '/keepcon/social_accounts'

  onError: =>
    swal({
      title: I18n.t('social_accounts.google_play.create.error_notification.title'),
      text: I18n.t('social_accounts.google_play.create.error_notification.text'),
      type: 'error',
      showCancelButton: false,
      confirmButtonClass: 'close',
      cancelButtonClass: 'close',
      confirmButtonText: I18n.t('social_accounts.google_play.create.error_notification.button_text'),
      closeOnConfirm: true
    })
    swal.close = => @redirectToSocialAccounts()

  close: ->
    @$el.children('.tab-content').empty().addClass('processing')
    @modalTab.destroy()
